export default "__VITE_ASSET__yWOBPh6Q__"